document.addEventListener("DOMContentLoaded", function () {
  const btns = document.querySelectorAll(".collection-desc-btn");

  btns.forEach(btn => {
    btn.addEventListener("click", function () {
      const wrap = btn.closest(".collection-desc-wrapper");
      const shortText = wrap.querySelector(".collection-desc-short");
      const fullText = wrap.querySelector(".collection-desc-full");

      if (fullText.style.display === "none") {
        fullText.style.display = "block";
        shortText.style.display = "none";
        btn.textContent = "Read Less";
      } else {
        fullText.style.display = "none";
        shortText.style.display = "block";
        btn.textContent = "Read More";
      }
    });
  });
});
